<template>
  <div class="p-grid">
    <Toast position="bottom-left" />
    <form
      ref="form"
      v-if="model"
      class="p-col-12"
      @submit.prevent="submitForm"
      method="POST"
    >
      <Panel header="ENUM" :toggleable="true">
        <div class="p-fluid">
          <div class="p-field">
            <label> ENUM</label>
            <InputText
              dir="ltr"
              placeholder="Example: Product"
              v-model="model.name"
              type="text"
            />
          </div>

          <div class="p-field">
            <label>نام ENUM</label>
            <InputText
              placeholder="مثلا محصول"
              type="text"
              v-model="model.label"
            />
          </div>

          <div class="p-field">
            <label>نام جمع ENUM</label>
            <InputText
              placeholder="مثلا محصولات"
              type="text"
              v-model="model.pluralLabel"
            />
          </div>

          <div class="p-field">
            <label>آیکون</label>
            <InputText
              dir="ltr"
              placeholder="pi pi-check"
              type="text"
              v-model="model.icon"
            />
            <div class="p-text-left">
              <a
                href="https://www.primefaces.org/primevue/showcase/#/icons"
                target="_blank"
                >Icons List</a
              >
            </div>
          </div>
        </div>
      </Panel>
      <br />
      <Panel header="فیلدهای ENUM" :toggleable="true">
        <DataTable
          :value="model.fields"
          :filters="filters"
          :loading="loading"
          data-key="id"
        >
          <template #empty>ستونی یافت نشد</template>
          <Column
            v-for="col of columns"
            :field="col.field"
            :header="col.header"
            :key="col.field"
            :sortable="col.sortable"
          >
            <template #filter v-if="col.filterable">
              <InputText
                type="text"
                v-model="filters[col.field]"
                @keypress.enter="filterBy"
                class="p-column-filter"
              />
            </template>
          </Column>
          <Column header="مدیریت" v-if="columns">
            <template #body="slotProps">
              <Button
                icon="pi pi-pencil"
                class="p-button-rounded p-button-success p-ml-2"
                @click="showEditFieldDialog(slotProps.data)"
              />
              <Button
                icon="pi pi-trash"
                class="p-button-rounded p-button-warning"
                @click="confirmDeleteField(slotProps.data)"
              />
            </template>
          </Column>
        </DataTable>

        <br />
        <div class="p-col-12 p-fluid">
          <Button
            label="ستون جدید"
            @click="newFieldDialog = true"
            icon="pi pi-plus"
            class="p-button-primary p-mr-2"
          />
        </div>

        <Dialog
          :visible.sync="deleteFieldDialog"
          :style="{ width: '450px' }"
          header="تایید حذف"
          :modal="true"
        >
          <div class="confirmation-content">
            <i
              class="pi pi-exclamation-triangle p-mr-3"
              style="font-size: 2rem"
            />
            <span>آیا از حذف مورد انتخاب شده مطمئن هستید؟</span>
          </div>
          <template #footer>
            <Button
              label="خیر"
              icon="pi pi-times"
              class="p-button-text"
              @click="deleteFieldDialog = false"
            />
            <Button
              label="بله"
              icon="pi pi-check"
              class="p-button-text"
              @click="deleteField"
            />
          </template>
        </Dialog>

        <Dialog
          :visible.sync="newFieldDialog"
          :style="{ width: '650px' }"
          header="اطلاعات ستون"
          :modal="true"
        >
          <div class="p-fluid">
            <vue-form-generator
              :schema="fieldSchema"
              :model="fieldModel"
            ></vue-form-generator>
          </div>
          <template #footer>
            <Button
              label="لغو"
              icon="pi pi-times"
              class="p-button-text"
              @click="newFieldDialog = false"
            />
            <Button
              label="ذخیره"
              icon="pi pi-check"
              class="p-button-text"
              @click="updateField"
            />
          </template>
        </Dialog>
      </Panel>

      <br />
      <Button
        type="submit"
        :disabled="submiting"
        class="p-button-success p-mr-2"
        >{{ !submiting ? "ذخیره تغییرات" : "در حال ارسال" }}</Button
      >
    </form>
  </div>
</template>
<script>
import CrudService from "../../service/CrudService";
import fields from "./fields.js";
import "@/assets/layout/form-generator.scss";
import helper from "../../helper";

export default {
  data() {
    return {
      filters: {},
      columns: [
        { field: "name", header: "Field" },
        { field: "label", header: "نام" },
        { field: "value", header: "مقدار" },
      ],
      loading: true,
      listItems: null,
      fieldModel: { id: 0 },
      item: null,
      deleteFieldDialog: false,
      newFieldDialog: false,
      model: null,
      submiting: false,
      fieldSchema: { fields: [] },
    };
  },
  service: null,
  methods: {
    removeRelation(id) {
      this.model.parentRelations = this.model.parentRelations.filter(
        (x) => x.id != id
      );
    },
    newRelation() {
      this.model.parentRelations.push({ id: 0, title: "" });
    },
    updateField() {
      if (!this.item) {
        //create mode
        let fieldModel = {};
        for (const key in this.fieldModel) {
          fieldModel[helper.toCamelCase(key)] = this.fieldModel[key];
        }
        fieldModel.id = -1 * Math.round(new Date().valueOf() / 1000);
        fieldModel.value = parseInt(fieldModel.value);
        this.model.fields.push(fieldModel);
      } else {
        //edit mode
        let editingColumn = this.model.fields.find((x) => x.id == this.item.id);

        for (const key in this.fieldModel) {
          editingColumn[helper.toCamelCase(key)] = this.fieldModel[key];
        }
        editingColumn.value = parseInt(editingColumn.value);
      }

      this.fieldModel = { id: 0 };
      this.newFieldDialog = false;
    },
    deleteField() {
      this.model.fields = this.model.fields.filter(
        (item) => item.id !== this.item.id
      );
      this.deleteFieldDialog = false;
      this.item = null;
    },

    confirmDeleteField(item) {
      this.item = item;
      this.deleteFieldDialog = true;
    },
    showEditFieldDialog(item) {
      this.item = item;

      let fieldModel = {};
      for (const key in this.item) {
        fieldModel[helper.toPascalCase(key)] = this.item[key];
      }

      this.fieldModel = fieldModel;
      this.newFieldDialog = true;
    },
    async submitForm() {
      this.submiting = true;
      const success = await this.service.update(this.model);
      helper.toastSubmitResult(success, this.$toast);

      this.submiting = false;
    },
  },
  async created() {
    this.service = new CrudService("Enum", this);
    this.model = await this.service.getItem(this.$route.params.id);
    this.fieldSchema.fields = fields;

    this.loading = false;
  },
};
</script>